// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck

import { AV_LANGUAGES, DEBUG_MODE } from './enums';
import { resolve } from '@/index';
import { $store } from '@/ts/store';
import { EventInterface } from '@splidejs/splide';

//Generic function to debug;
export function debug(msg: string, type: number = DEBUG_MODE.NOTICE) {
    const currLvl = $store.get().debugLevel || 0;
    if (currLvl >= type) {
        let color,
            heading = '';
        switch (type) {
            case DEBUG_MODE.ERROR:
                heading = '📕 Error:';
                color = DEBUG_MODE.E_COLOR;
                break;
            case DEBUG_MODE.WARNING:
                heading = '📒 Warning:';
                color = DEBUG_MODE.W_COLOR;
                break;
            case DEBUG_MODE.NOTICE:
                heading = '🗒️ Notice:';
                color = DEBUG_MODE.N_COLOR;
                break;
        }
        console.log(
            `%c${heading} %c${msg} 🏴‍☠️`,
            `
        color: ${color};
        font-family: sans-serif;
        font-size: .9rem;
        padding: .5rem;
    `,
            `color: inherit;
        font-family: sans-serif;
        font-size: .8rem;
        padding: .5rem;
        padding-left: 0;
    `
        );
    }
}

//Generic function usable in cases of repeated events;
export function debounce(callback: any, timeout = 500) {
    let timer: any;
    //@ts-ignore
    let context: any = this;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            callback.apply(context, args);
        }, timeout);
    };
}

//The function manage all dynamic Tags;
export function replaceTags() {
    window.dynamicTags &&
        Object.keys(dynamicTags.tags).forEach(tagValue => {
            if (!tagValue.includes('__static')) {
                dynamicTags.tags[tagValue].wait();
                resolve.run(tagValue).finally(() => {
                    dynamicTags.tags[tagValue].stop();
                });
            } else {
                dynamicTags.tags[tagValue].stop();
            }
        });
}

//The function manage all dynamic Tags with id data-last-update, replacing them with a date;
export function lastUpdateHandlers() {
    const lastUpdateHandler = new ResolverHandler('last-update');

    lastUpdateHandler.register(() => {
        const lastUpdate = document.querySelector('[data-last-update]')?.getAttribute('data-last-update');
        if (lastUpdate) {
            const htmlLang = document.querySelector('html') ? document.querySelector('html').getAttribute('lang') : '';
            const currentLanguage: string = htmlLang && AV_LANGUAGES.find(lang => lang.includes(htmlLang)) ? AV_LANGUAGES.find(lang => lang.includes(htmlLang)) : 'en-GB';
            const date = new Date(lastUpdate);

            dynamicTags.tags['last-update'].replace(
                date.toLocaleDateString(currentLanguage, {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                })
            );
        }
    });
}

//The function detect all timestamp in page, and replace them with a real date based on current language;
export function replaceTimestamp(timestamp = '') {
    const htmlLang = document.querySelector('html') ? document.querySelector('html').getAttribute('lang') : '';
    const currentLanguage: string = htmlLang && AV_LANGUAGES.find(lang => lang.includes(htmlLang)) ? AV_LANGUAGES.find(lang => lang.includes(htmlLang)) : 'en-GB';
    const $timestamps = document.querySelectorAll('[data-replace-timestamp]');

    $timestamps.forEach(($t: any) => {
        let value = $t.innerText ? $t.innerText : $t.innerHTML ? $t.innerHTML : ('' as any);

        if (!$t.innerText) {
            value = $t.querySelector('a') ? $t.querySelector('a').innerHTML : value;
        }

        let currentTimestamp = value && !isNaN(Number(value.trim())) ? Number(value.trim()) : '';
        const mustBeMultiplied = currentTimestamp.toString().length < 13;
        const multiplier = mustBeMultiplied ? 1000 : 1;
        const currentDate = currentTimestamp ? new Date(currentTimestamp * multiplier) : null;

        if (currentDate) {
            $t.innerHTML = currentDate.toLocaleDateString(currentLanguage, {
                day: '2-digit',
                month: 'long',
                year: 'numeric',
            });
        }
    });

    if (timestamp) {
        let currentTimestamp = timestamp && !isNaN(Number(timestamp.trim())) ? Number(timestamp.trim()) : '';
        currentTimestamp = currentTimestamp.toString().length < 13 ? currentTimestamp * 1000 : currentTimestamp;
        const currentDate = currentTimestamp ? new Date(currentTimestamp) : new Date();

        return currentDate.toLocaleDateString(currentLanguage, {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        });
    }
}


//The function return a decimal separator, based on current language;
export function getDecimalSeparator(locale?) {
    const numberWithDecimalSeparator = 1.1;
    return Intl.NumberFormat(locale)
        .formatToParts(numberWithDecimalSeparator)
        .find(part => part.type === 'decimal').value;
}


//The function expose a method, usable from an external way;
export function expose(name: string, callback: Function) {
    expose.catalog = expose.catalog || {};
    if (typeof callback === 'function') {
        expose.catalog[name] = callback;
    }

    window['cactusRetrieve'] =
        window['cactusRetrieve'] ||
        function (id) {
            return expose.catalog[id];
        };
}

//The function return a rounded version of an array of percentages;
export function approximateArray(array) {
    if (!Array.isArray(array) || array.length === 0) {
        throw new Error('Array vuoto');
    }
    const arrayEl = array.map(el => {
        return {
            ...el,
            percentage: Number(el.percentage * 100),
        };
    });

    const roundedArray = arrayEl.map(item => ({
        ...item,
        percentage: Math.round(item.percentage),
    }));

    const difference = roundedArray.reduce((acc, item, index) => acc + (item.percentage - roundedArray[index].percentage), 0);

    const adjustedArray = roundedArray.map((item, index) => {
        if (index === 0) {
            return { ...item, percentage: item.percentage - difference };
        }
        return item;
    });

    return adjustedArray;
}

export function bindCarousel(Splide: any, Components: any) {
    const { bind } = EventInterface(Splide);
    const { Move } = Components;
    const { list } = Components.Elements;

    let endCallback: any;

    function mount() {
        bind(list, 'transitionend', e => {
            if (e.target === list && endCallback) {
                cancel();

                endCallback();
            }
        });
    }

    function start(index: any, done: any) {
        const destination = Move.toPosition(index, true);

        list.style.transition = 'all 600ms cubic-bezier(.44,.65,.07,1.01)';

        Move.translate(destination);

        endCallback = done;
    }

    function cancel() {
        list.style.transition = '';
    }

    return {
        mount,
        start,
        cancel,
    };
}
